module.exports = __webpack_public_path__ + "static/media/bass.72b6b193.mp3";